<template>
  <ul class="filters">
    <li :class="{'active': !filter}" @click="setFilter(null)">Alle</li>
    <li
      v-for="_filter in sortedFilters"
      :class="{'active': _filter === filter}"
      @click="setFilter(_filter)">
      {{_filter}}
    </li>
  </ul>
</template>

<script>
import { union } from 'lodash'
export default {
  name: 'Filters',
  data () {
    return {
      filter: null,
      /**
       * Should NOT be hardcoded!!
       */
      priorityFilters: [
        'Intro',
        'Øjentræningøvelser',
        'Individuelle øvelser',
        'Parøvelser',
        'Gruppeøvelser',
        'Outro'
      ]
    }
  },
  props: {
    filters: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    setFilter (filter) {
      this.filter = filter
      this.$emit('filter', filter)
    }
  },
  computed: {
    computedFilters () {
      return this.filters.map(filter => filter[0])
    },
    sortedFilters () {
      // sort filters by priority but unset filters that are not in computed (= have zero exercises)
      return union(this.priorityFilters, this.computedFilters).filter(item => this.computedFilters.includes(item))
    }
  }
}
</script>

<style lang="scss" scoped>
.filters {
  display: flex;
  flex-wrap: wrap;
  margin: 0px;
  margin-bottom: 2rem;
  padding: 0px;
  list-style: none;
  font-weight: bold;

  li {
    margin-right: 1rem;
    cursor: pointer;

    &.active, &:hover {
      opacity: 0.5;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Filters.vue?0ec56181